export default __webpack_public_path__ + "static/SOLID SURFACES-63568f7b9f95bbedb648ec063fefb555.webp";